<template>
  <div>
    <div v-if="isLoading" class="isLoading">
      <img src="/wp-content/themes/genesis-go2roues/svg/Spinner-1s-200px.svg" alt="spinner">
      <em>{{ loadingMessage }}</em>
    </div>
    <div v-if="! isLoading && score < 0.5">
      <p>La vérification de sécurité a échoué. Veuillez nous contacter par téléphone.</p></div>
    <form ref="form" v-show="!done">
      <template v-if="! isLoading && score > 0.5">
        <fieldset class="vos-infos">
          <legend>Pour toutes questions veuillez remplir le formulaire ci-dessous ou nous contacter par téléphone.
          </legend>
          <div class="contact__grid_2">
            <label for="prenom">Prénom</label>
            <input type="text" id="prenom" v-model="first_name"
              placeholder="Prénom..." required>
          </div>
          <div class="contact__grid_2">
            <label for="nom">Nom</label>
            <input id="nom" type="text" v-model="last_name"
              placeholder="Nom..." required>
          </div>
          <div class="contact__grid_2">
            <label for="tel">Téléphone</label>
            <input id="tel" type="tel" v-model="phone"
              placeholder="Téléphone..." minlength="10" maxlength="10"
              required
              pattern="^(?:0|\(?\+33\)?\s?|0033\s?)[1-79](?:[\.\-\s]?\d\d){4}$">
          </div>
          <div class="contact__grid_2">
            <label for="email">Email</label>
            <input id="email" type="email" v-model="email"
              placeholder="Votre email..." required>
          </div>
          <div class="contact__grid_2">
            <label for="service">Votre question concerne :</label>
            <select v-model.number="service" id="service">
              <option value="1">Question sur un produit</option>
              <option value="2">Suivi de Commande</option>
              <option value="3">Service Après Vente</option>
              <option value="4">Partenariat</option>
            </select>
          </div>
          <label for="message">Votre message</label>
          <!--suppress CheckTagEmptyBody -->
          <textarea v-model="message" placeholder="..." id="message"
            cols="30" rows="8" required maxlength="2500"></textarea>
          <template v-if="! userLoggedIn">
            <label for="rgpd">
              <input type="checkbox" v-model="rgpd" required
                id="rgpd">J'autorise GO2ROUES à enregistrer mes informations afin de pouvoir me répondre.</label>
          </template>
          <button type="button" @click="submit" ref="button">ENVOYER</button>
        </fieldset>
      </template>
    </form>
    <div v-show="done" class="done">
      <AnimatedCheckMark :done="done"/>
      <p ref="doneMessage">Merci, nous avons bien reçu votre message et vous répondrons dans les meilleurs délais.</p>
    </div>
  </div>
</template>

<script>
import AnimatedCheckMark from "../partials/AnimatedCheckMark";

export default {
  name: "ContactezNous",
  components: {AnimatedCheckMark},
  data() {
    return {
      isLoading: true,
      loadingMessage: 'Vérification de sécurité...',
      score: 0,
      first_name: '',
      last_name: '',
      email: '',
      phone: '',
      message: '',
      service: 1,
      userData: {},
      rgpd: false,
      sending: false,
      done: false,
    }
  },
  computed: {
    userLoggedIn() {
      return g2rObj.hasOwnProperty('userId');
    },
  },
  watch: {
    done(newVal) {
      if (newVal) {
        setTimeout(() => this.$refs.doneMessage.style.opacity = '1', 1200);
      } else {
        this.$refs.doneMessage.style.opacity = '0';
      }
    },
  },
  methods: {
    async recaptcha() {
      // (optional) Wait until recaptcha has been loaded.
      await this.$recaptchaLoaded();
      // Execute reCAPTCHA with action "contact".
      const token = await this.$recaptcha('contact');
      // Do stuff with the received token.
      $api.post('g2r/v1/grecaptcha', {token: token})
        .then(response => response.data)
        .then(data => {
          this.score = data.score;
          if (g2rObj.hasOwnProperty('userId') && this.score > 0.5) {
            this.loadingMessage = `Chargement des données utilisateurs...`;
            this.getUserData();
          } else {
            this.isLoading = false;
          }
        })
    },
    getUserData() {
      $api.get(`wc/v3/customers/${g2rObj.userId}`)
        .then(response => response.data)
        .then(data => {
          this.userData = data;
          ['first_name', 'last_name', 'email'].forEach(field => this[field] = data[field]);
          ['phone'].forEach(field => this[field] = data.billing[field]);
          this.isLoading = false;
        })
    },
    submit() {
      if (this.$refs.form.checkValidity()) {
        if (!this.sending) {
          this.sending = true;
          this.$refs.button.innerHTML = `ENVOI...`;
          $api.post('g2r/v1/contact/submit', this.$data)
            .then(response => response.data)
            .then(data => {
              if (data) {
                this.done = true;
              }
            })
            .finally(() => {
              this.$refs.button.innerHTML = `ENVOYER`
              this.sending = false
            })
        }
      } else {
        this.$refs.form.reportValidity()
      }
    },
  },
  beforeMount() {
    this.recaptcha();
  },
  mounted() {
    const params = new URLSearchParams(document.location.search)
    if (params.has('devenir') && 'franchise' === params.get('devenir')) {
      this.service = 3
    }
  },
}
</script>

<style scoped lang="scss">

.isLoading {
  display: grid;
  justify-items: center;
  margin-top: 3rem;
}

form {
  margin-bottom: 3rem;
}

[for="rgpd"] {
  margin: 1rem auto 2rem;
  display: block;

  [type="checkbox"] {
    margin-right: .5rem
  }
}

@media screen and (min-width: 568px) {

  .contact__grid_2 {
    display: grid;
    grid-template-columns: 30% 65%;
    grid-column-gap: 5%;
    margin-bottom: 1rem;

    label {
      align-self: center;
      justify-self: right;
    }

    input, select {
      margin-bottom: 0;
    }

  }
}

.done {
  margin: 12rem auto;
  text-align: center;

  p {
    opacity: 0;
    transition: .3s opacity;
  }
}

</style>
